export default "__VITE_ASSET__C9uFO7o3__"